import { PlayerStat } from "../components/Carousel/PlayerCardsContainer";
import { Game, PlayerStats } from "../types/types"



export interface CalculatePlayerStatsProps {
    games: Game[];
}
export function CalculatePlayerStats({games}:CalculatePlayerStatsProps) {
    if (!games[0]) {
        let ret = {
            'price': -1,
            'be': -1,
            
            'threeFive': `-1`,
            'three': -1,
            'five': -1,
            'rawPrice': -1,
            'posranks': -1,
        }
        return ret
    }
    let lastgame = games[0];
    let formattedPrice = "";
    formattedPrice = lastgame.price.toLocaleString('en-US', { style: "currency", currency: "USD"});
    let ret = {
        'price': formattedPrice,
        'be': lastgame.scbe,
        
        'threeFive': `${lastgame.threeRoundAverage}/${lastgame.fiveRoundAverage}`,
        'three': lastgame.threeRoundAverage,
        'five': lastgame.fiveRoundAverage,
        'rawPrice': lastgame.price,
        'posranks': lastgame.positionrank,
    }
    return ret;

}